// extracted by mini-css-extract-plugin
export var actionButton = "_i9-0";
export var fileInput = "_i9-2";
export var paperclip = "_i9-1";